const statuses = new Set(["pending", "syncing", "waiting", "completed", "failed"]);
const validDate = value => value && Number.isFinite(new Date(value).getTime()) ? value : null;
export const isConnectionOffline = connection => connection?.status !== "CONNECTED";
export const getReconnectFrom = connection => validDate(connection?.disconnectedSince) || validDate(connection?.recoveryFrom);
export const getConnectionRecovery = connection => {
  const status = connection?.recoveryStatus;
  if (!statuses.has(status)) return null;
  const number = Number(connection.recoveryProcessed);
  const processed = Number.isFinite(number) ? Math.max(0, Math.floor(number)) : 0;
  const offline = isConnectionOffline(connection);
  const error = String(connection.recoveryError || "").trim();
  return {
    status, processed, from: validDate(connection.recoveryFrom), until: validDate(connection.recoveryUntil),
    active: ["pending", "syncing", "waiting"].includes(status),
    running: status === "syncing",
    failed: status === "failed",
    completed: status === "completed",
    title: ({ pending: "Recuperação preparada", syncing: "Recuperando mensagens", waiting: "Aguardando mensagens do WhatsApp", completed: "Mensagens disponíveis recuperadas", failed: "A recuperação precisa de atenção" })[status],
    description: status === "failed"
      ? (error && !/^ERR_|\n\s*at\s/.test(error) ? error : "Não foi possível concluir a recuperação. Verifique a conexão do WhatsApp.")
      : status === "completed"
        ? processed ? "As mensagens disponibilizadas pelo WhatsApp foram recuperadas e os atendimentos, atualizados." : "Nenhuma mensagem nova encontrada no período disponibilizado pelo WhatsApp."
        : offline ? "Reconecte o WhatsApp para continuar a recuperação das mensagens e dos atendimentos."
          : status === "waiting" ? "Aguardando o WhatsApp disponibilizar mais mensagens do período. A recuperação continuará automaticamente."
            : status === "pending" ? "A recuperação das mensagens do período será iniciada nesta conexão."
              : "Buscando as mensagens do período e restaurando os atendimentos.",
  };
};
export const connectionNeedsAttention = connection => !connection?.isTest && (isConnectionOffline(connection) || getConnectionRecovery(connection)?.failed === true);
export const connectionIsRecovering = connection => !connection?.isTest && getConnectionRecovery(connection)?.active === true;
export const showConnectionInAlerts = connection => !connection?.isTest && (isConnectionOffline(connection) || Boolean(getConnectionRecovery(connection)));
